import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../components/login/Login";
import Register from "../components/register/Register";
import StoreList from "../components/stores/StoreList";
import StorePage from "../components/stores/StorePage";
import PlayPage from "../components/quiz/PlayPage";
import MyCoupons from "../components/coupons/MyCoupons";
import Plans from "../components/subscription/Plans";
import MySubscription from "../components/subscription/MySubscription";
import AboutPage from "../components/about/AboutPage";
import AuthLayout from "../layout/AuthLayout";
import MainLayout from "../layout/MainLayout";
import ProtectedLayout from "../layout/ProtectedLayout";

export default function AppRouter() {
  return (
    <Routes>
      {/* Açılış → mağaza siyahısı (login tələb olunmur — QR axını) */}
      <Route path="/" element={<Navigate to="/stores" replace />} />

      {/* Login / Register */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Route>

      {/* Public səhifələr — QR skan edən qonaq birbaşa oynaya bilir */}
      <Route element={<MainLayout />}>
        <Route path="/stores" element={<StoreList />} />
        <Route path="/store/:id" element={<StorePage />} />
        {/* QR hədəfi: konkret kampaniya */}
        <Route path="/play/:merchantId/:quizId" element={<PlayPage />} />
        {/* Abunəlik paketləri — qiymət səhifəsi */}
        <Route path="/plans" element={<Plans />} />
        {/* Haqqında — admin paneldən idarə olunur */}
        <Route path="/about" element={<AboutPage />} />
      </Route>

      {/* Yalnız login olmuş müştəri */}
      <Route element={<ProtectedLayout />}>
        <Route path="/coupons" element={<MyCoupons />} />
        <Route path="/subscription" element={<MySubscription />} />
      </Route>

      {/* Köhnə URL-lər üçün yönləndirmə */}
      <Route path="/quiz" element={<Navigate to="/stores" replace />} />

      <Route path="*" element={<Navigate to="/stores" replace />} />
    </Routes>
  );
}
